module.exports = __webpack_public_path__ + "img/galeria-ornamentales-2.d7c67586.jpg";